import { useQuery } from '@tanstack/react-query';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import type { OfferSelectionData } from '~/types/services/parityNotifications';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

const EMPTY_SELECTION: OfferSelectionData = { ratePlans: [], properties: [], roomTypes: [], roomRates: [] };

export function useGetOfferSelectionData(offerId: string, vendorId: string, enabled: boolean) {
  return useQuery({
    queryKey: parityNotificationQueryKeys.offerSelection(offerId, vendorId),
    queryFn: ({ signal }) => ParityNotificationsService.getOfferSelectionData(offerId, vendorId, signal),
    enabled,
    retry: false,
    placeholderData: EMPTY_SELECTION,
  });
}
